import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/hyperlink/style.scss";
import "@ingka/inline-message/style.scss";
import "@ingka/focus/style.scss";
import InlineMessage from "@ingka/inline-message";
import { useEffect } from "react";
import style from './msgToast.module.scss';
import { useSessionStore } from "../../store/sessionStore";

export default function MsgToast(props) {
  const { deleteMsgToast } = useSessionStore()
  const closeToast = (e) =>{
    deleteMsgToast(parseInt(e.target.id))
  }

  useEffect(()=>{
    setTimeout(()=>{
      deleteMsgToast(props.id)
    },6000)
  },[])

  return (
    <InlineMessage
      className={style.toast}
      {...props}
      dismissable
      onDismissClick={closeToast}
    />
  )
}
